import { PubOwnerDomain, PubOwnerRole } from "../api/cafe";

export const roleOptions = [
  { name: "모든 토너먼트 접근 가능", value: PubOwnerRole.MANAGER },
  { name: "특정 토너먼트 접근 가능", value: PubOwnerRole.STAFF },
];

export const domainOptions = [
  { name: "전체", value: null },
  { name: "토너먼트", value: PubOwnerDomain.TOURNAMENT },
  { name: "예약 관리", value: PubOwnerDomain.RESERVATION },
  { name: "펍 관리", value: PubOwnerDomain.MANAGEMENT },
  { name: "마케팅 서비스", value: PubOwnerDomain.MARKETING },
  { name: "티켓 관리", value: PubOwnerDomain.TICKET },
  { name: "정산", value: PubOwnerDomain.SETTLEMENT },
  { name: "회원 관리", value: PubOwnerDomain.MEMBER },
  { name: "이벤트", value: PubOwnerDomain.EVENT },
];

export const getSelectableDomains = (): PubOwnerDomain[] =>
  domainOptions
    .filter((item) => item.value !== null)
    .map((item) => item.value as PubOwnerDomain);

export const fromApiDomains = (
  domains: PubOwnerDomain[],
): { isAllDomains: boolean; selectedDomains: PubOwnerDomain[] } => {
  if (domains.length === 0) {
    return { isAllDomains: true, selectedDomains: [] };
  }

  return { isAllDomains: false, selectedDomains: domains };
};

export const toApiDomains = (
  isAllDomains: boolean,
  selectedDomains: PubOwnerDomain[],
): PubOwnerDomain[] => {
  const allDomains = getSelectableDomains();
  const isEveryDomainSelected =
    selectedDomains.length > 0 &&
    allDomains.every((domain) => selectedDomains.includes(domain));

  if (isAllDomains || isEveryDomainSelected) {
    return [];
  }

  return selectedDomains;
};

export const isDomainChecked = (
  domain: PubOwnerDomain | null,
  isAllDomains: boolean,
  selectedDomains: PubOwnerDomain[],
): boolean => {
  const allDomains = getSelectableDomains();
  const isEveryDomainSelected =
    selectedDomains.length > 0 &&
    allDomains.every((item) => selectedDomains.includes(item));
  const isAll = isAllDomains || isEveryDomainSelected;

  if (domain === null) {
    return isAll;
  }

  return isAll || selectedDomains.includes(domain);
};

export const getRoleName = (domains: PubOwnerDomain[], role: PubOwnerRole) => {
  if (role === PubOwnerRole.OWNER) return "ALL";
  if (domains.length === 0) return "ALL";

  let names = [];
  if (domains.includes(PubOwnerDomain.TOURNAMENT)) {
    names.push("토너먼트");
  }
  if (domains.includes(PubOwnerDomain.RESERVATION)) {
    names.push("예약");
  }
  if (domains.includes(PubOwnerDomain.MANAGEMENT)) {
    names.push("관리");
  }
  if (domains.includes(PubOwnerDomain.MARKETING)) {
    names.push("마케팅");
  }
  if (domains.includes(PubOwnerDomain.SETTLEMENT)) {
    names.push("정산");
  }
  if (domains.includes(PubOwnerDomain.MEMBER)) {
    names.push("회원");
  }
  return names.join(", ");
};

export const isPubOwner = (role?: PubOwnerRole, domains?: PubOwnerDomain[]) => {
  return role === PubOwnerRole.OWNER || domains?.length === 0;
};

export const isPubManager = (role?: PubOwnerRole) => {
  return role === PubOwnerRole.MANAGER;
};

export const isPubStaff = (role?: PubOwnerRole) => {
  return role === PubOwnerRole.STAFF;
};

export const isTournamentAccess = (
  tournamentId: number,
  accessTournamentIds?: number[],
) => {
  if (!accessTournamentIds) return false;
  if (accessTournamentIds.length === 0) return true;
  if (accessTournamentIds.includes(+tournamentId)) return true;
  return false;
};

export const isDomainTournament = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.TOURNAMENT);
};

export const isDomainReservation = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.RESERVATION);
};

export const isDomainManagement = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.MANAGEMENT);
};

export const isDomainMarketing = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.MARKETING);
};

export const isDomainSettlement = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.SETTLEMENT);
};

export const isDomainMember = (
  domains?: PubOwnerDomain[],
  role?: PubOwnerRole,
) => {
  if (isPubOwner(role, domains)) return true;
  return domains?.includes(PubOwnerDomain.MEMBER);
};
